import { api } from '../../../api/api';
// import { LoginResponse, RequestLogin } from './types';

const INVOICES_TAG = 'invoices';

export const activateApi = api.enhanceEndpoints({ addTagTypes: [INVOICES_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    activateValidation: build.mutation<{ simValue: string; validSim: boolean }, { iccid: string }>({
      query: ({ iccid }) => ({
        method: 'POST',
        url: 'activation/validate',
        body: { iccid }
      })
    }),
    getValidationCode: build.mutation<
      {
        valid: boolean;
        message: string;
        iccid: string;
        esim_manual_update?: string | null;
        reservation_id?: string | null;
      },
      { code: string }
    >({
      query: ({ code }) => ({
        method: 'POST',
        url: 'activation/validate-activation-code',
        body: { activationCode: code }
      })
    }),
    getValidationICCID: build.mutation<
      {
        message: string;
        validSim: boolean;
        esim_manual_update?: string | null;
        reservation_id?: string | null;
      },
      { iccid: string }
    >({
      query: ({ iccid }) => ({
        method: 'POST',
        url: 'activation/validate-iccid',
        body: { iccid }
      })
    }),
    sendPricingTableData: build.mutation<
      { message: string },
      {
        'client-reference-id': string;
        'customer-email': string;
        'customer-session-client-secret'?: string;
      }
    >({
      query: (data) => ({
        method: 'POST',
        url: 'activation/log-price-table',
        body: data
      })
    }),
    checkSolarSim: build.mutation<
      { 
        success: boolean; 
        is_solar_sim: boolean; 
        pricing_table_id: string; 
        location: string 
      }, 
      { iccid: string; location: string }
    >({
      query: ({ iccid, location }) => ({
        method: 'POST',
        url: 'activation/check-solar-sim',
        body: { iccid, location }
      })
    }),
    trackReferral: build.mutation<
      { success: boolean; message: string },
      { ref: string; email: string; iccid?: string }
    >({
      query: (body) => ({
        method: 'POST',
        url: 'trade/track-referral',
        body
      })
    })
  })
});

export const {
  useActivateValidationMutation,
  useGetValidationCodeMutation,
  useGetValidationICCIDMutation,
  useSendPricingTableDataMutation,
  useCheckSolarSimMutation,
  useTrackReferralMutation
} = activateApi;
